// extracted by mini-css-extract-plugin
module.exports = {"categoryWrapper":"category-tile_categoryWrapper__f3OUm"};